const customLogout = () => {
    if (document.querySelector('.ume-custom-logout')) {
        document.addEventListener('click', ev => {
            if (!ev.target.parentNode.matches('.ume-custom-logout')) return;
            ev.preventDefault();
            window.location.href = wp_environment.ume_logout_url;
        })
    }
}
export default customLogout;
